import { render, staticRenderFns } from "./ActionHeader.vue?vue&type=template&id=1ffe4697&"
import script from "./ActionHeader.vue?vue&type=script&lang=js&"
export * from "./ActionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports